import type { AxiosInstance } from "axios";

export interface DigitalSampleRequestCreate {
  requester?: string;
  comment?: string;
  eljExperimentId: string;
  eljExperimentBatch: string;
  materialGrade: string;
  materialColorCode?: string;
  preliminaryColorCode?: string;
  materialFinish: string;
  assignee?: string;
}

export interface DigitalSampleRequestCreateResponse {
  message?: string;
  error?: Error;
}

export function createDigitalSampleRequest(
  axios: AxiosInstance,
  request: DigitalSampleRequestCreate,
): Promise<DigitalSampleRequestCreateResponse> {
  return axios
    .post("/v0/digital-sample-management/digital-sample-requests", request)
    .then((_res) => ({ message: "Digital Sample Request created!" }))
    .catch((e) => ({ error: e }));
}
